export default __webpack_public_path__ + "static/media/10.4af9694a.jpg";